/** Project Management — strictement lecture seule dans Todo (DT décision A2) :
 * aucune fonction de mutation ne doit être ajoutée ici. */
import { pmRequest } from "./client";

export interface PmProject {
  id: string;
  tenant_id: string;
  code: string;
  name: string;
  description?: string;
  status: string;
  type: string;
  priority: string;
  owner_id: string;
  start_date?: string;
  end_date?: string;
  progress_pct: number;
}

export interface PmWorkItem {
  id: string;
  tenant_id: string;
  project_id: string;
  parent_id?: string;
  path: string;
  type: string;
  title: string;
  description?: string;
  status: string;
  priority: string;
  assignee_ids: string[];
  reporter_id: string;
  start_date?: string;
  due_date?: string;
  completed_at?: string;
  progress_pct: number;
  tags: string[];
  position: number;
}

interface PmPaged<T> {
  items: T[];
  next_cursor?: string;
}

export function listProjects(cursor?: string): Promise<PmPaged<PmProject>> {
  return pmRequest({
    method: "GET",
    url: "/projects",
    params: { limit: 200, ...(cursor ? { cursor } : {}) },
  });
}

export function getProject(id: string): Promise<PmProject> {
  return pmRequest({ method: "GET", url: `/projects/${id}` });
}

export function listWorkItems(
  projectId: string,
  cursor?: string,
): Promise<PmPaged<PmWorkItem>> {
  return pmRequest({
    method: "GET",
    url: `/projects/${projectId}/work-items`,
    params: { limit: 200, ...(cursor ? { cursor } : {}) },
  });
}
